import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  FormControl,
  FormLabel,
  Grid,
  Slide,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import React, { forwardRef, Fragment, useEffect, useState } from 'react';
import {
  toReadableDateTimeString,
  toSummaryBirthDate,
} from '../../utils/dateFormatter';
import { LoadingButton } from '@mui/lab';
import { toCurrencyForm } from '../../utils/stringFormatter';
import FormTextField from '../FormTextField/FormTextField';
import api from '../../services/apiClient';
import { getDiscountValue } from '../../utils/numberFormatter';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const TicketSummaryData = ({
  label,
  text,
  width = '100%',
  letterSpacing,
  multiline,
}) => (
  <TextField
    sx={{
      marginBottom: '10px',
      width: width,
      letterSpacing,
    }}
    defaultValue={text}
    label={label}
    size="small"
    multiline={multiline}
    InputProps={{
      readOnly: true,
    }}
  />
);

const VirtualTicketSummary = ({
  showSummary,
  event,
  onClose,
  isLoading = false,
  category,
  participants,
  order,
  addons,
  onChoosePayment,
}) => {
  const isMobile = useMediaQuery('(max-width: 899px)');

  // console.log(event);
  // console.log(category);
  // console.log(participants);
  // console.log(order);
  const [coupon, setCoupon] = useState({ code: '', data: {} });
  const [isGetCouponData, setIsGetCouponData] = useState(false);
  const [bill, setBill] = useState();

  //#region use effect
  useEffect(() => {
    if (!showSummary) return;
    const regFee = parseInt(event?.registrationFee);
    const addOnPrice = parseInt(getAddOnsTotalPrice(addons));
    setBill(regFee + addOnPrice + getShippingFee());
    setCoupon({ code: '', data: {} });
  }, [event, showSummary]);
  //#endregion

  //#region function
  const handleOnClose = () => {
    if (isLoading) return;

    onClose();
  };

  const handleDataChange = (e) => {
    const updated = { ...coupon };
    updated.code = e.target.value;
    setCoupon(updated);
  };

  const handleGetCouponData = async () => {
    // console.log('ts-event ', event);
    // console.log('ts-coupon ', coupon);
    // return console.log(coupon);
    if (coupon.code === '') return alert('Input Coupon Code.');

    try {
      setIsGetCouponData((prev) => !prev);
      const { data: couponData } = await api.get(
        `/events/offline/coupon/${event?.eventId}/${coupon.code}/${category?.categoryId}`
        // `/events/offline/coupon/${event?.eventId}/${coupon.code}`
      );

      const updated = { ...coupon };
      updated['data'] = couponData;
      // console.log('ticket summary get coupon data');
      // console.log(updated);
      setCoupon(updated);

      const totalBill = getTotalBill(
        event?.registrationFee,
        couponData?.coupon_category,
        couponData?.coupon_value,
        addons
      );

      setBill(totalBill);

      setIsGetCouponData((prev) => !prev);
    } catch (error) {
      setIsGetCouponData((prev) => !prev);
      setCoupon({ code: '', data: {} });
      alert(error.response.data);
    }
  };

  const handleOnChoosePayment = () => {
    // console.log(event.eventId);
    // if (event?.eventId !== 64 && event?.eventId !== 66)
    //   return onChoosePayment({ bill, coupon });

    // if (sohmWaiverChecked === false)
    //   return alert('Please agree our waiver to continue your transaction.');
    const shippingFee = getShippingFee();
    onChoosePayment({ bill, coupon, addons, shippingFee });
  };

  const getTotalBill = (
    registrationFee,
    couponCategory,
    couponValue,
    addons
  ) => {
    let totalBill = parseInt(registrationFee);
    let value = parseInt(couponValue);

    let result = 0;
    switch (couponCategory) {
      case 'sale':
        result = parseInt(totalBill) - parseInt(value);
        break;
      case 'discount':
        result = totalBill - (totalBill * value) / 100;
        break;
      default:
        result = totalBill;
        break;
    }
    const addonsPrice = getAddOnsTotalPrice(addons);

    result += addonsPrice;
    result += getShippingFee();
    // console.log(result);
    return result;
  };

  const getAddOnsTotalPrice = (addons) => {
    let addonsPrice = 0;

    addons.forEach((el, idx) => {
      // console.log(`price addons ke ${idx + 1}`, el.price);
      if (el.selected === true && parseInt(el.price) > 0)
        addonsPrice += parseInt(el.price);
    });

    // console.log(addonsPrice);

    return addonsPrice;
  };

  const getAddOnsSelected = (addons) => {
    let total = 0;
    addons.forEach((ad) => (ad.selected ? (total += 1) : (total += 0)));

    return total;
  };

  const getShippingFee = () => {
    const selectedAddons = addons?.filter((ad) => ad.selected === true);
    if (selectedAddons?.length === 0 && event?.isFreeShippingOnNoAddons > 0)
      return 0;

    return parseInt(event?.shippingFee);
  };
  //#endregion
  return (
    <Fragment>
      <Dialog fullScreen open={showSummary} TransitionComponent={Transition}>
        <DialogContent sx={{ padding: { xs: '2rem 2rem', lg: '2rem 4rem' } }}>
          <Card>
            <CardContent>
              <Grid container spacing={2}>
                {/* left tab */}
                <Grid item xs={12} md={3}>
                  {/* event event */}
                  <Typography variant="h5" gutterBottom>
                    Event Info
                  </Typography>
                  <Box
                    sx={{
                      m: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      flexGrow: 1,
                    }}
                  >
                    <TicketSummaryData
                      text={event?.name}
                      label={'Name'}
                      multiline={true}
                    />
                    <TicketSummaryData
                      text={category?.categoryName}
                      label={'Category'}
                      multiline={true}
                    />
                    <TicketSummaryData
                      text={toReadableDateTimeString(event?.startDate)}
                      label={'Submission Start'}
                      letterSpacing={1}
                    />
                    <TicketSummaryData
                      text={toReadableDateTimeString(event?.endDate)}
                      label={'Submission End'}
                      letterSpacing={1}
                    />
                  </Box>
                </Grid>

                {/* tab middle */}
                <Grid item xs={12} md={6}>
                  {/* email */}
                  <Typography variant="h5">Email</Typography>
                  <Box sx={{ m: 1 }}>
                    <TicketSummaryData text={order?.email?.value} />
                  </Box>

                  {/* participants */}
                  <Typography variant="h5" sx={{ marginBottom: '10px' }}>
                    {participants?.length === 1
                      ? 'Participant'
                      : 'Participants'}
                  </Typography>
                  <Grid item container className={'scroll'}>
                    {participants?.map((pt, idx) => (
                      <Grid key={idx} item xs={12} lg={6}>
                        <DialogContentText variant="h5" align="center">
                          Runner {idx + 1}
                        </DialogContentText>
                        <Box
                          sx={{
                            m: 1,
                            display: 'flex',
                            flexDirection: 'column',
                          }}
                        >
                          <TicketSummaryData
                            text={pt?.firstName?.value}
                            label={'First Name'}
                          />
                          <TicketSummaryData
                            text={pt?.lastName?.value}
                            label={'Last Name'}
                          />
                          <TicketSummaryData
                            text={pt?.gender?.value}
                            label={'Gender'}
                          />
                          {event?.eventId === 71 && (
                            <TicketSummaryData
                              text={pt?.jenisAnjing?.value || '-'}
                              label={'Jenis Anjing'}
                            />
                          )}
                          <TicketSummaryData
                            text={toSummaryBirthDate(pt?.birthDate?.value)}
                            label={'Birhtdate (dd/mm/yyyy)'}
                            letterSpacing={1}
                          />
                          <TicketSummaryData
                            text={pt?.phoneNumber?.value}
                            label={'Phone Number'}
                          />
                          {!!pt?.size?.value && (
                            <TicketSummaryData
                              text={pt?.size?.value}
                              label={'Size'}
                            />
                          )}
                          <TicketSummaryData
                            text={pt?.street?.value}
                            label={'Alamat'}
                          />
                          <TicketSummaryData
                            text={pt?.area?.value}
                            label={'Kelurahan'}
                          />
                          <TicketSummaryData
                            text={pt?.suburb?.value}
                            label={'Kecamatan'}
                          />
                          <TicketSummaryData
                            text={pt?.city?.value}
                            label={'Kota'}
                          />
                          <TicketSummaryData
                            text={pt?.province?.value}
                            label={'Provinsi'}
                          />
                          <TicketSummaryData
                            text={pt?.postalCode?.value}
                            label={'Kode Pos'}
                          />
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>

                {/* tab right */}
                <Grid item xs={12} md={3}>
                  {
                    //#region addons
                  }
                  <Typography variant="h5" gutterBottom>
                    AddOns
                  </Typography>
                  <Box
                    borderRadius={'14px'}
                    sx={{
                      m: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      border: 3,
                      borderColor: 'grey.200',
                      p: 2,
                    }}
                  >
                    {addons?.length > 0 ? (
                      <>
                        {addons?.map((ad, idx) => {
                          if (ad.selected === false) return null;

                          return (
                            <>
                              <Box display={'flex'}>
                                <FormLabel
                                  sx={{
                                    fontSize: '16px',
                                    flexGrow: 1,
                                    fontWeight: '600',
                                  }}
                                >
                                  Name
                                </FormLabel>
                                <Typography variant="body1" fontWeight={'600'}>
                                  {ad.name}
                                </Typography>
                              </Box>
                              {ad.addonType === 'jersey' && (
                                <Box display={'flex'}>
                                  <FormLabel
                                    sx={{
                                      fontSize: '16px',
                                      flexGrow: 1,
                                      fontWeight: '600',
                                    }}
                                  >
                                    Size
                                  </FormLabel>
                                  <Typography
                                    variant="body1"
                                    fontWeight={'600'}
                                  >
                                    {ad.selectedSize.value.toUpperCase()}
                                  </Typography>
                                </Box>
                              )}
                              <Box display={'flex'}>
                                <FormLabel
                                  sx={{
                                    fontSize: '16px',
                                    flexGrow: 1,
                                    fontWeight: '600',
                                  }}
                                >
                                  Price
                                </FormLabel>
                                <Typography variant="body1" fontWeight={'600'}>
                                  {ad.price.toString() !== '0'
                                    ? `Rp ${toCurrencyForm(ad.price)}`
                                    : 'Free'}
                                </Typography>
                              </Box>
                              <Divider style={{ margin: '4px 0' }} />
                            </>
                          );
                        })}
                        <Box display={'flex'}>
                          <FormLabel
                            sx={{
                              fontSize: '16px',
                              flexGrow: 1,
                              fontWeight: '600',
                            }}
                          >
                            {getAddOnsSelected(addons) > 0
                              ? 'Total Price'
                              : 'No AddOns Selected'}
                          </FormLabel>
                          <Typography variant="body1" fontWeight={'600'}>
                            {getAddOnsTotalPrice(addons) > 0
                              ? `Rp ${toCurrencyForm(
                                  getAddOnsTotalPrice(addons)
                                )}`
                              : '-'}
                          </Typography>
                        </Box>
                      </>
                    ) : (
                      <TicketSummaryData text={'No AddOns Selected.'} />
                    )}
                  </Box>
                  {
                    //#endregion
                  }

                  {/* {
                    //#region insurance
                  }
                  {event?.isInsuranceBundled > 0 && (
                    <Box
                      display={'flex'}
                      justifyContent={'flex-start'}
                      marginBottom={'10px'}
                      flexDirection={'column'}
                      borderRadius={'14px'}
                      padding={'10px 16px'}
                      flex={1}
                      sx={{
                        border: 3,
                        borderColor: 'grey.200',
                      }}
                    >
                      <Box>
                        <Box display={'flex'} alignItems={'center'}>
                          <FormLabel
                            sx={{
                              fontSize: '20px',
                              flexGrow: 1,
                              fontWeight: '600',
                            }}
                          >
                            {'Insurance'}
                          </FormLabel>
                          <img
                            src={prodigiLogo}
                            alt="prodigi"
                            style={{
                              height: '24px',
                              width: '100px',
                              objectFit: 'contain',
                            }}
                          />
                        </Box>

                        <Divider style={{ margin: '10px 0' }} />
                        <Box display={'flex'}>
                          <FormLabel
                            sx={{
                              fontSize: '16px',
                              flexGrow: 1,
                              fontWeight: '600',
                            }}
                          >
                            {'Asuransi Kecelakaan Diri'}
                          </FormLabel>
                          <Typography variant="body1" fontWeight={'600'}>
                            {'Bundled'}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  )}
                  {
                    //#endregion
                  } */}

                  {
                    //#region coupons
                  }
                  {/* <Typography variant="h5" gutterBottom>
                    Fee
                  </Typography> */}
                  <Box
                    display={'flex'}
                    justifyContent={'flex-start'}
                    marginBottom={'10px'}
                    flexDirection={'column'}
                    borderRadius={'14px'}
                    padding={'10px 16px'}
                    flex={1}
                    sx={{
                      border: 3,
                      borderColor: 'grey.200',
                    }}
                  >
                    <Box display={'flex'}>
                      <FormLabel
                        sx={{
                          fontSize: '16px',
                          flexGrow: 1,
                          fontWeight: '600',
                        }}
                      >
                        Registration Fee
                      </FormLabel>
                      <Typography variant="body1" fontWeight={'600'}>
                        {event?.registrationFee === '0'
                          ? 'FREE'
                          : `Rp ${toCurrencyForm(event?.registrationFee)}`}
                      </Typography>
                    </Box>
                    <Box display={'flex'}>
                      <FormLabel
                        sx={{
                          fontSize: '16px',
                          flexGrow: 1,
                          fontWeight: '600',
                        }}
                      >
                        Shipping Fee
                      </FormLabel>
                      <Typography variant="body1" fontWeight={'600'}>
                        {getShippingFee() === 0
                          ? 'FREE'
                          : `Rp ${toCurrencyForm(getShippingFee())}`}
                      </Typography>
                    </Box>
                    {coupon?.data?.coupon_category && (
                      <Box display={'flex'}>
                        <FormLabel
                          sx={{
                            fontSize: '16px',
                            flexGrow: 1,
                            fontWeight: '600',
                          }}
                        >
                          {coupon?.data?.coupon_category === 'discount'
                            ? `Disc(${coupon?.data?.coupon_value}%)`
                            : coupon?.data?.coupon_category}
                        </FormLabel>
                        <Typography variant="body1" fontWeight={'600'}>
                          {coupon?.data?.coupon_category === 'sale'
                            ? `Rp ${toCurrencyForm(coupon?.data?.coupon_value)}`
                            : `Rp ${toCurrencyForm(
                                getDiscountValue(
                                  event?.registrationFee,
                                  coupon?.data?.coupon_value
                                )
                              )}`}
                        </Typography>
                      </Box>
                    )}
                    <Divider
                      sx={{
                        marginTop: '4px',
                        marginBottom: '4px',
                        marginLeft: { xs: '78%', sm: '82%', md: '60%' },
                      }}
                    />
                    <Box display={'flex'}>
                      <FormLabel
                        sx={{
                          fontSize: '16px',
                          flexGrow: 1,
                          fontWeight: '600',
                        }}
                      >
                        Total Bill
                      </FormLabel>
                      <Typography variant="body1" fontWeight={'600'}>
                        {bill > 0 ? `Rp ${toCurrencyForm(bill)}` : 'FREE'}
                      </Typography>
                    </Box>
                    {event?.isCoupon > 0 && (
                      <Divider sx={{ margin: '4px 0' }} />
                    )}

                    {event?.isCoupon > 0 && (
                      <FormControl>
                        <FormLabel
                          id="coupon-form"
                          sx={{ fontSize: '18px', fontWeight: '600' }}
                        >
                          Coupon
                        </FormLabel>
                        <Box sx={{ marginTop: '10px' }}>
                          <FormTextField
                            index={0}
                            i={0}
                            label={'Coupon Code'}
                            value={coupon.code}
                            readOnly={!!coupon?.data?.code}
                            disabled={!!coupon?.data?.code}
                            onChange={handleDataChange}
                          />
                          <LoadingButton
                            variant="contained"
                            fullWidth
                            onClick={handleGetCouponData}
                            loading={isGetCouponData}
                            disabled={!!coupon?.data?.code}
                          >
                            Use Coupon
                          </LoadingButton>
                        </Box>
                      </FormControl>
                    )}
                  </Box>

                  {isMobile && (
                    <Box
                      sx={{
                        marginTop: '20px',
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      {!isLoading && (
                        <Button autoFocus onClick={handleOnClose}>
                          Close
                        </Button>
                      )}
                      <LoadingButton
                        onClick={handleOnChoosePayment}
                        autoFocus
                        loading={isLoading}
                      >
                        {bill > 0 ? 'Choose Payment' : 'Register'}
                      </LoadingButton>
                    </Box>
                  )}
                  {
                    //#endregion
                  }
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </DialogContent>
        {!isMobile && (
          <DialogActions>
            {!isLoading && (
              <Button autoFocus onClick={handleOnClose}>
                Close
              </Button>
            )}
            <LoadingButton
              onClick={handleOnChoosePayment}
              autoFocus
              loading={isLoading}
            >
              {bill > 0 ? 'Choose Payment' : 'Register'}
            </LoadingButton>
          </DialogActions>
        )}
      </Dialog>
    </Fragment>
  );
};

export default VirtualTicketSummary;
